import { Col, Form, Modal, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getPrimeContractList } from '../../api/constlink';
import { styledTable } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledTable}
`;
const { Option } = Select;

interface ImportPrimeContractModalProps {
  visible: boolean;
  enterpriseId: string;
  onCreate: (userIdList: number[]) => void;
  onCancel: () => void;
}

function ImportPrimeContractModal({
  visible,
  enterpriseId,
  onCreate,
  onCancel,
}: ImportPrimeContractModalProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [primeContractOptions, setPrimeContractOptions] = useState<any>();

  useEffect(() => {
    if (!mount) return;
    (async () => {
      let primeContractList = await getPrimeContractList({ enterpriseId });

      let children: any = [];
      for (const primeContract of primeContractList.sort((a: any, b: any) =>
        b.contractDate.localeCompare(a.contractDate),
      )) {
        children.push(
          <Option key={primeContract.id} value={primeContract.id}>
            {primeContract.title} ({primeContract.contractDate})
          </Option>,
        );
      }
      setPrimeContractOptions(children);
    })();
    return () => setMount(false);
  }, [enterpriseId, mount]);

  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="기존 도급계약에서 집계내역 불러오기"
        okText="확인"
        cancelText="취소"
        width={800}
        onCancel={onCancel}
        onOk={() => {
          form.validateFields().then((value) => {
            onCreate(value);
          });
        }}
      >
        {primeContractOptions && (
          <Row justify={'center'}>
            <Form form={form} layout="inline" initialValues={{}}>
              <Col span={14}>
                <Form.Item name="primeContractId">
                  <Select
                    style={{ width: '400px' }}
                    placeholder="도급계약을 선택하세요"
                  >
                    {primeContractOptions}
                  </Select>
                </Form.Item>
              </Col>
            </Form>
          </Row>
        )}
      </Modal>
    </StyledDiv>
  );
}

export default ImportPrimeContractModal;
